module.exports = __webpack_public_path__ + "img/L.1f6ce81f.png";